import PropTypes from 'prop-types';
import React from 'react';

import {IDType} from 'scripts/utils/prop-types';

import QuestionnaireEntry from './QuestionnaireEntry';

const QuestionnaireList = ({questionnaires}) => (
    <div className="w-full flex flex-col items-center">
        <div className="w-full flex flex-col space-y-4 items-center max-w-3xl px-4">
            {questionnaires.map(id => <QuestionnaireEntry key={id} id={id} />)}
        </div>
    </div>
);

QuestionnaireList.propTypes = {
    questionnaires: PropTypes.arrayOf(IDType).isRequired,
};

export default QuestionnaireList;



// WEBPACK FOOTER //
// ./scripts/frontend/questionnaires/components/QuestionnaireList.js